/**
 * Created by henian.xu on 2018/7/18.
 *
 */

import { Sp } from './Sp';

class ShopStoreLevel extends Sp {
    constructor() {
        super();
        this.baseUrl += '/shopStoreLevel';
    }

    data({ levelName, isAvailable, currentPage, pageSize } = {}) {
        return super.get('/data', {
            levelName,
            isAvailable,
            currentPage,
            pageSize,
        });
    }

    getDetail({ id }) {
        return super.get('/get', { id }).then(json => {
            const { levelIcon } = json.data.data;
            const { fileBasePath } = json.data.data;
            if (!levelIcon) {
                json.data.data.levelIcon = [];
            } else {
                json.data.data.levelIcon = levelIcon.split(',').reduce((prev, curr) => {
                    prev.push({
                        name: curr,
                        address: fileBasePath + curr,
                    });
                    return prev;
                }, []);
            }
            return json;
        });
    }

    save({ id, levelName, levelDesc, levelIcon, isAvailable, orderNum } = {}) {
        const levelIconStr = levelIcon
            .reduce((prev, curr) => {
                prev.push(curr.name);
                return prev;
            }, [])
            .join(',');
        return super.post('/save', {
            id,
            levelName,
            levelDesc,
            levelIcon: levelIconStr,
            isAvailable,
            orderNum,
        });
    }

    delete({ ids } = {}) {
        return super.post('/delete', {
            ids,
        });
    }

    saveGoodsShopStoreLevel({ goodsIds, shopStoreLevelId }) {
        return super.post('/saveGoodsShopStoreLevel', { goodsIds, shopStoreLevelId });
    }

    delGoodsShopStoreLevel({ goodsIds, shopStoreLevelId }) {
        return super.post('/delGoodsShopStoreLevel', { goodsIds, shopStoreLevelId });
    }
}

export default new ShopStoreLevel();
export { ShopStoreLevel };
